const formatDateForFilter = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
    return '';
  }

  const year = date.getFullYear();
  const month = `${date.getMonth() + 1}`.padStart(2, '0');
  const day = `${date.getDate()}`.padStart(2, '0');

  return `${year}-${month}-${day}`;
};

const parseDateInput = (dateInput) => {
  if (!dateInput) {
    return null;
  }

  const parsedDate = dateInput instanceof Date
    ? new Date(dateInput.getTime())
    : new Date(dateInput);

  if (Number.isNaN(parsedDate.getTime())) {
    return null;
  }

  return parsedDate;
};

export const getFilterPayloadValues = (payload) => {
  if (payload && typeof payload === 'object' && !Array.isArray(payload)) {
    return {
      searchText: payload.search?.toString().toLowerCase() || '',
      startDate: payload.startDate || payload.date || '',
      endDate: payload.endDate || payload.date || '',
      actionValue: payload.action?.toString().toLowerCase() || '',
    };
  }

  return {
    searchText: payload?.toString().toLowerCase() || '',
    startDate: '',
    endDate: '',
    actionValue: '',
  };
};

export const getLocalDateFilterValue = (dateInput) => {
  const parsedDate = parseDateInput(dateInput);

  return parsedDate ? formatDateForFilter(parsedDate) : '';
};

export const getShiftedDateFilterValue = (dateInput, offsetHours = 0) => {
  const parsedDate = parseDateInput(dateInput);

  if (!parsedDate) {
    return '';
  }

  const shiftedDate = new Date(parsedDate.getTime() + offsetHours * 60 * 60 * 1000);

  return formatDateForFilter(shiftedDate);
};

export const isDateWithinRange = (dateValue, startDateInput, endDateInput) => {
  const normalizedStartDate = getLocalDateFilterValue(startDateInput);
  const normalizedEndDate = getLocalDateFilterValue(endDateInput);

  if (!normalizedStartDate && !normalizedEndDate) {
    return true;
  }

  if (!dateValue) {
    return false;
  }

  if (normalizedStartDate && dateValue < normalizedStartDate) {
    return false;
  }

  if (normalizedEndDate && dateValue > normalizedEndDate) {
    return false;
  }

  return true;
};
